<script setup lang="ts">
import { computed, ComputedRef, inject } from 'vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const isReadOnly = inject('isReadOnly')
const kodIrz = inject('kodIrz') as ComputedRef<string | undefined>

// TODO: toto bude treba tahat odniekial zhora podla toho z ktorej page (za akych okolnosti) sa cely form renderuje
type StadiumVyzvy = 'readonly' | 'readwrite' | 'draft' | 'podana'

const vyzvaMod = computed<StadiumVyzvy>(() => {
  if (isReadOnly) {
    return 'readonly'
  }
  // TODO: dories viac pripadov
  return 'readwrite'
})

const kodTitle = computed(() => {
  switch (vyzvaMod.value) {
    case 'readwrite':
      return t('zoppm.step1.identifikatorRozpracovanejZiadosti')
    default: // case readonly
      return t('zoppm.step1.kodProjektu')
  }
})

const kod = computed(() => {
  switch (vyzvaMod.value) {
    case 'readwrite':
      return kodIrz.value?.replace(/"/g, '')
    default: // case readonly
      return t('zoppm.step1.zatialNeprideleny')
  }
})
</script>

<template>
  <div class="mb-9">
    <IDSKParagraph>
      <DisplayList variant="">
        <template v-if="vyzvaMod === 'readonly'"></template>
        <dt>{{ kodTitle }}:</dt>
        <dd>
          <i>{{ kod }}</i>
        </dd>
      </DisplayList>
    </IDSKParagraph>
    <ValidationWrapper v-slot="slotProps" name="projekt.nazov">
      <IDSKTextarea v-bind="slotProps" :label="t('zoppm.step1.nazovProjektu')" />
    </ValidationWrapper>
    <ValidationWrapper v-slot="slotProps" name="projekt.kratkyNazov">
      <IDSKInput
        v-bind="slotProps"
        :label="t('zoppm.step1.kratkyNazovProjektu')"
        :hint="t('zoppm.step1.kratkyNazovProjektuHint')"
      />
    </ValidationWrapper>

    <ValidationWrapper v-slot="slotProps" name="projekt.ciel">
      <IDSKTextarea
        v-bind="slotProps"
        :label="t('zoppm.step1.cielProjektu')"
        :hint="t('zoppm.step1.cielProjektuHint')"
      />
    </ValidationWrapper>

    <ValidationWrapper v-slot="slotProps" name="projekt.popis">
      <IDSKTextarea
        v-bind="slotProps"
        :label="t('zoppm.step1.popisProjektu')"
        :hint="t('zoppm.step1.popisProjektuHint')"
      />
    </ValidationWrapper>
  </div>
</template>

<style lang="scss"></style>
